import { useField } from 'formik'
import { SelectProps } from 'components/Select/Types'
import { Chip } from 'components/Chip/Chip'
import Styles from './StringInput.module.scss'
import cx from 'classnames'

interface Props extends Omit<SelectProps<string>, 'name' | 'children'> {
  name: string
  isCarousel?: boolean
  size?: 'sm' | 'md' | 'lg'
  children: JSX.Element[]
  chipVariant?: 'catalogue' | 'flat' | 'wizard' | 'wizardsV3' | 'filter' | 'button'
}

export const SelectPillsMultiInput = (props: Props) => {
  const [field, , helpers] = useField<string[]>(props.name)
  const chipVariant = props.chipVariant || 'catalogue'
  const values = field.value || []

  const toggleValue = (value: string) => {
    if (values.includes(value)) {
      helpers.setValue(values.filter((v) => v !== value))
    } else {
      helpers.setValue([...values, value])
    }
  }

  return (
    <div className={cx(Styles.chipsInput, { [Styles.isCarousel]: props.isCarousel })}>
      {props.children.map((option) => (
        <Chip
          deletable={false}
          variant={chipVariant}
          key={option.key}
          onPress={() => toggleValue(option.key as string)}
          isSelected={values.includes(option.key as string)}
          size={props.size}
        >
          {option.key}
        </Chip>
      ))}
    </div>
  )
}
